export default "__VITE_PUBLIC_ASSET__54a280aa__"